import { render, staticRenderFns } from "./OptionsTags.vue?vue&type=template&id=a51315b6&scoped=true&"
import script from "./OptionsTags.vue?vue&type=script&lang=js&"
export * from "./OptionsTags.vue?vue&type=script&lang=js&"
import style0 from "./OptionsTags.vue?vue&type=style&index=0&id=a51315b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51315b6",
  null
  
)

export default component.exports